export const loginText = {
  en: {
    title: 'Church in Cerritos',
    subtitle: 'Bible Reading Tracker',
    desc: 'Enter your name and email to get started.\nYour reading history will be linked to your name.',
    namePlaceholder: 'Your name (e.g. John Doe)',
    emailPlaceholder: 'Your email',
    button: 'Enter',
    loading: 'Checking...',
    errorBoth: 'Please enter both your name and email.',
    errorEmail: 'Please enter a valid email address.',
    errorTaken: 'This name is already taken. Please choose a different name.',
    errorGeneric: 'Something went wrong. Please try again.',
    recoverAsk: 'Forgot your name?',
    recoverSending: 'Sending…',
    recoverNeedEmail: 'Enter your email above first.',
    recoverSent: 'If that address has an account, we have emailed the name to it.',
    google: 'Continue with Google',
    orDivider: 'or',
    googleFinish: 'One more step — choose the name your reading will show under.',
    googleSignedIn: 'Signed in with Google as',
  },
  es: {
    title: 'Iglesia en Cerritos',
    subtitle: 'Seguimiento de Lectura Bíblica',
    desc: 'Ingresa tu nombre y correo para comenzar.\nTu historial de lectura se vinculará a tu nombre.',
    namePlaceholder: 'Tu nombre (p.ej. Juan Doe)',
    emailPlaceholder: 'Tu correo electrónico',
    button: 'Entrar',
    loading: 'Verificando...',
    errorBoth: 'Por favor ingresa tu nombre y correo.',
    errorEmail: 'Por favor ingresa un correo válido.',
    errorTaken: 'Este nombre ya está en uso. Por favor elige otro.',
    errorGeneric: 'Algo salió mal. Por favor intenta de nuevo.',
    recoverAsk: '¿Olvidaste tu nombre?',
    recoverSending: 'Enviando…',
    recoverNeedEmail: 'Primero ingresa tu correo arriba.',
    recoverSent: 'Si esa dirección tiene una cuenta, le enviamos el nombre.',
    google: 'Continuar con Google',
    orDivider: 'o',
    googleFinish: 'Un paso más: elige el nombre con el que aparecerá tu lectura.',
    googleSignedIn: 'Sesión iniciada con Google como',
  },
  zh: {
    title: '喜瑞督召會',
    subtitle: '讀經記錄',
    desc: '請輸入您的姓名和電子郵件以開始。\n您的閱讀記錄將與您的姓名連結。',
    namePlaceholder: '您的姓名（例如：吳大明）',
    emailPlaceholder: '您的電子郵件',
    button: '進入',
    loading: '檢查中...',
    errorBoth: '請輸入您的姓名和電子郵件。',
    errorEmail: '請輸入有效的電子郵件地址。',
    errorTaken: '此姓名已被使用，請選擇其他姓名。',
    errorGeneric: '發生錯誤，請重試。',
    recoverAsk: '忘記你的名稱？',
    recoverSending: '寄送中…',
    recoverNeedEmail: '請先在上方輸入電子郵件。',
    recoverSent: '若該地址有帳號，我們已將名稱寄出。',
    google: '使用 Google 登入',
    orDivider: '或',
    googleFinish: '還有一步——請選擇顯示閱讀記錄的名稱。',
    googleSignedIn: '已用 Google 登入：',
  },
  sc: {
    title: '喜瑞督召会',
    subtitle: '读经记录',
    desc: '请输入您的姓名和电子邮件以开始。\n您的阅读记录将与您的姓名关联。',
    namePlaceholder: '您的姓名（例如：吴大明）',
    emailPlaceholder: '您的电子邮件',
    button: '进入',
    loading: '检查中...',
    errorBoth: '请输入您的姓名和电子邮件。',
    errorEmail: '请输入有效的电子邮件地址。',
    errorTaken: '此姓名已被使用，请选择其他姓名。',
    errorGeneric: '发生错误，请重试。',
    recoverAsk: '忘记你的名称？',
    recoverSending: '寄送中…',
    recoverNeedEmail: '请先在上方输入电子邮件。',
    recoverSent: '若该地址有帐号，我们已将名称寄出。',
    google: '使用 Google 登录',
    orDivider: '或',
    googleFinish: '还有一步——请选择显示阅读记录的名称。',
    googleSignedIn: '已用 Google 登录：',
  },
};
